// `Model` from its own module, not the `@/models` barrel — see the note in `index.ts`.
import { Model } from './model';
import { type NetworkBlob } from '@/models';
import { DateTime } from 'luxon';

interface IBlob {
    identifier: string;
    name: string;
    contentType: string;
    size: number;
    storedAt: Date;
    hasThumbnail: boolean;
    thumbnailKey?: string;
    hasDisplayCopy?: boolean;
    conversionFailed?: boolean;
}

export class BlobModel extends Model {
  identifier: string;
  name: string;
  contentType: string;
  size: number;
  storedAt?: Date;
  hasThumbnail?: boolean;
  thumbnailKey?: string;
  /** The worker has written a full-resolution JPEG of this blob, served at `blob/:id/display`. */
  hasDisplayCopy?: boolean;
  /** The worker tried to make this blob's derivatives and could not, so none are coming. */
  conversionFailed?: boolean;
  downloadedBlob?: string;

  file?: File;
  progress?: number;
  label?: string;
  isLoading?: boolean;

  /**
   * The browser's own object URL for a file uploaded in this session, drawn until the server
   * thumbnail arrives. Cleared when the browser cannot decode it, which for a HEIC in Chrome or
   * Firefox is always.
   */
  localPreviewUrl?: string;

  constructor({
    identifier,
    name,
    contentType,
    size,
    storedAt,
    hasThumbnail,
    hasDisplayCopy,
    conversionFailed
  }: IBlob) {
    super();
    this.identifier = identifier;
    this.name = name;
    this.contentType = contentType;
    this.size = size;
    this.storedAt = storedAt;
    this.hasThumbnail = hasThumbnail;
    this.hasDisplayCopy = hasDisplayCopy;
    this.conversionFailed = conversionFailed;
  }

  static mapFromBackend(networkBlob: NetworkBlob) {
    return new BlobModel({
      identifier: networkBlob.identifier,
      name: networkBlob.name,
      contentType: networkBlob.contentType,
      size: networkBlob.size,
      storedAt: DateTime.fromISO(networkBlob.storedAt).toJSDate(),
      hasThumbnail: networkBlob.hasThumbnail,
      thumbnailKey: networkBlob.thumbnailKey,
      hasDisplayCopy: networkBlob.hasDisplayCopy,
      conversionFailed: networkBlob.conversionFailed
    });
  }
}
